//@flow
import React from 'react';
import { filter, isEmpty } from 'lodash';
import { useEffect, useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { RouteNames } from 'router';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { RouteUtil } from 'utils/RouteUtil';
import { HomeSelector } from 'modules/home/selector';
import { CmsPagesSelector } from 'modules/cmsPages/selector';
import { HomeActions } from 'modules/home/actions';
import { bindActionCreators } from 'redux';
import type { SiteSettings, Vertical } from 'types/common';
import MainMenuVerticalCard from 'components/molecules/verticalsCard';
import { SocialLinks } from 'components/molecules/socialLinks';
import { InfoLinks } from 'components/molecules/infoLinks';
import { HeaderLinks } from 'components/molecules/headerButton';
import Offerings from 'components/molecules/offerings';
import { Copyright } from 'components/atoms/copyright';
import axios from 'axios';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  verticals: Array<Vertical>,
  siteSettings: SiteSettings,
  onClosePress: () => void,
  theme: string,
  fullPageApi?: () => void,
};
const MainMenuDesktop = (props: Props) => {
  const {
    verticals,
    siteSettings,
    onClosePress,
    theme,
    fullPageApi,
    offeringPages,
    machineCraft,
    getHeaderData,
    getheaderData,
    eDesign,
  } = props;

  let sortedVerticals = filter(verticals, function(n) {
    return n.id !== 11;
  });
  useEffect(() => {
    getHeaderData();
  }, []);
  let totalVerticalCheck = sortedVerticals.length;

  const socialLinks = siteSettings.social;

  const infoLinks = [
    !isEmpty(offeringPages.aboutData)
      ? { title: 'About', link: RouteNames.about }
      : {},
    !isEmpty(offeringPages.careerData)
      ? { title: 'Careers', link: RouteNames.careers }
      : {},
    !isEmpty(offeringPages.contactData)
      ? { title: 'Contact', link: RouteNames.contact }
      : {},
    // { title: 'Blog', link: RouteNames.blog },
  ];

  const offerings = [
    !isEmpty(machineCraft)
      ? {
          title: 'Machine Craft',
          // link: '/homes#machine-craft',
          link: '/homes',
          sectionId: 'machine-craft',
        }
      : {},
    !isEmpty(offeringPages.craftBeerData)
      ? { title: 'Craft Beer', link: '/craftbeer-and-brewery' }
      : {},
    !isEmpty(eDesign)
      ? {
          title: 'eDesign',
          // link: '/homes#eDesign',
          link: '/homes',
          sectionId: 'eDesign',
        }
      : {},
    !isEmpty(offeringPages.propertyData)
      ? { title: 'Property Management', link: '/property-management' }
      : {},
    !isEmpty(offeringPages.thinkDesignData)
      ? { title: 'Think Design', link: '/think-design' }
      : {},
    // !isEmpty(offeringPages.musicData)
    //   ? { title: 'Music Foundation', link: '/music-and-events' }
    //   : {}
  ];

  sortedVerticals.push(offerings);

  const renderHeaderContent = () => (
    <div className={'header-content'}>
      <h1 className={'menu-heading'}>{siteSettings.settings.menuContent}</h1>
      <div className={'social-info-container'}>
        <InfoLinks links={infoLinks} connectRoute={true} />
        <HeaderLinks links={getheaderData} connectRoute={true} />
        <SocialLinks theme={theme} links={socialLinks} />
      </div>
    </div>
  );

  const renderVerticals = () => {
    return (
      <Row className={'verticals-row'}>
        {sortedVerticals.map((item, idx) => (
          <Col md={3} key={idx} className={'vertical-column'}>
            {totalVerticalCheck === idx ? (
              <Offerings
                links={offerings}
                onPress={onClosePress}
                fullPageApi={fullPageApi}
              />
            ) : (
              <MainMenuVerticalCard
                key={idx}
                data={item}
                onPress={onClosePress}
              />
            )}
             {/* <MainMenuVerticalCard
                key={idx}
                data={item}
                onPress={onClosePress}
              /> */}
          </Col>
        ))}
      </Row>
    );
  };

  const renderFooter = () => <Copyright containerClass={'menu-copyright'} />;

  return (
    <div className={'menu-container'}>
      <div className={'menu-desktop-body'}>
        {renderHeaderContent()}
        {renderVerticals()}
        {renderFooter()}
      </div>
    </div>
  );
};
const mapDispatchToProps = dispatch => {
  const { getHeaderData } = HomeActions;
  return bindActionCreators(
    {
      getHeaderData,
    },
    dispatch
  );
};
const mapStateToProps = state => {
  return {
    offeringPages: HomeSelector.showOfferingPages(state),
    machineCraft: CmsPagesSelector.getCmsPages(state, 'Machine-craft', false),
    getheaderData: HomeSelector.getHeaderData(state),
    eDesign: CmsPagesSelector.getCmsPages(
      state,
      'Customise With eDesign',
      false
    ),
  };
};

const connectedComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(MainMenuDesktop);

export default withRouter(connectedComponent);
